export function isReportEnabledByPlan($store) {
  if($store.state.project.plan && $store.state.project.plan.id) {
    return $store.state.project.plan.enabled
  }

  return  !$store.state.project.directiveOff
}



// WEBPACK FOOTER //
// ./src/utils/permission.js